"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../utils/constants");
var _CTAButton = _interopRequireDefault(require("../../components/CTAButton"));
var _reactBootstrap = require("react-bootstrap");
var _lodash = require("lodash");
var _FinproProfileUtility = require("../../components/finpro/FinproProfileUtility");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _DisclosureModal = _interopRequireDefault(require("../../components/finpro/DisclosureModal"));
var _ListAgents = _interopRequireDefault(require("../../components/finpro/ListAgents"));
var _LeadFormModal = _interopRequireDefault(require("../../components/finpro/LeadFormModal"));
var _FinproHeadTags = _interopRequireDefault(require("../../components/finpro/headtag/FinproHeadTags"));
var _SinglePinMap = require("../../components/finpro/maps/SinglePinMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 *  A react component to create a Agency Profile
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering.fields.data Agency detail
 *
 * @returns {React.ReactElement} Agency profile
 */
function FinproAgencyProfile(props) {
  var _extractedFields$loca, _extractedFields$loca2;
  if (!props.rendering.fields || !props.rendering.fields.data) {
    return null;
  }
  var extractedFields = (0, _lodash.get)(props, 'rendering.fields.data');
  var isCoreoffice = extractedFields.officeType === _constants.CORE_OFFICE_TITLE;
  var socialLinksAvailable = extractedFields.socialAppList ? !(0, _lodash.isEmpty)(extractedFields.socialAppList.facebook) || !(0, _lodash.isEmpty)(extractedFields.socialAppList.linkedin) || !(0, _lodash.isEmpty)(extractedFields.socialAppList.twitter) || !(0, _lodash.isEmpty)(extractedFields.socialAppList.instagram) || !(0, _lodash.isEmpty)(extractedFields.socialAppList.youtube) : false;
  var formData = props.formParams;
  var showForm = formData && formData.fields;

  // Lead Form Modal event
  var [showLeadForm, setLeadForm] = (0, _react.useState)(false);
  var [leadFormData, setLeadFormData] = (0, _react.useState)(null);
  var handleLeadFormModalShow = props => {
    setLeadForm(true);
    setLeadFormData(props);
  };
  var handleLeadFormModalClose = () => {
    setLeadForm(false);
    setLeadFormData(null);
  };
  var ProcessHeadtags = () => {
    if (extractedFields.location) {
      var metadata = {
        pagePath: extractedFields.agencyUrl,
        pageQuery: props.params.pageQuery,
        utagSiteName: props.pageprops.utagSiteName,
        addUtagLoginCookie: props.pageprops.addUtagLoginCookie,
        name: extractedFields.agencyName,
        location: extractedFields.location,
        phone: extractedFields.location.phone,
        mapLink: (0, _FinproProfileUtility.GenerateGoogleMapLink)(extractedFields.location, true),
        agentList: extractedFields.agents.map(x => x.fullName.replace(/'/g, ''))
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'agency',
        metadata: metadata
      });
    } else {
      var _metadata = {
        pagePath: props.params.pagePath
      };
      return /*#__PURE__*/_react.default.createElement(_FinproHeadTags.default, {
        pageType: 'default',
        metadata: _metadata
      });
    }
  };
  var GetLeadFormLink = () => {
    if (showForm) {
      var label = 'Connect with us';
      var formProps = {
        coreAgencyNumber: extractedFields.coreAgencyNumber,
        subAgencyNumber: extractedFields.subAgencyNumber,
        agentId: '',
        agencyName: extractedFields.agencyName,
        modalTitle: label
      };
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "connect-form"
      }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
        buttonType: 'inline',
        label: label,
        dataId: (0, _FinproProfileUtility.GetCTADataId)(_constants.LEADS_CTA_LABEL, extractedFields.agencyUrl),
        icon: 'icon-ask',
        iconDirection: 'left',
        onClick: () => handleLeadFormModalShow(formProps)
      }));
    } else return null;
  };
  var GetCoreOffice = () => {
    var coreOffice = (0, _lodash.get)(extractedFields, 'coreAgency');
    if (coreOffice) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, _constants.CORE_OFFICE_TITLE), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
        itemscope: "",
        itemtype: "http://schema.org/InsuranceAgency"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "card-body"
      }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.OfficeTitleLink, {
        officeTitle: coreOffice.agencyName,
        titleSize: 'h4',
        officeLink: coreOffice.agencyUrl,
        className: 'card-title',
        schema: true
      }), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetAddress, _extends({}, coreOffice.location, {
        schema: true
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "card-footer"
      }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
        value: coreOffice.location.phone
      })))))));
    } else return null;
  };
  var GetSatelliteOffice = () => {
    var satelliteOffice = (0, _lodash.get)(extractedFields, 'subAgencies');
    if (satelliteOffice && satelliteOffice.length > 0) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h3", null, _constants.SATELLITE_OFFICE_TITLE), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
        className: "office-scroll-auto"
      }, (0, _lodash.map)(satelliteOffice, (office, officeIndex) => {
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
          lg: 12,
          md: 6,
          sm: 12,
          key: officeIndex,
          itemscope: "",
          itemtype: "http://schema.org/InsuranceAgency"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "card"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "card-body"
        }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.OfficeTitleLink, {
          officeTitle: office.agencyName,
          titleSize: 'h4',
          officeLink: office.agencyUrl,
          className: 'card-title',
          schema: true
        }), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetAddress, _extends({}, office.location, {
          schema: true
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "card-footer"
        }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
          value: office.location.phone
        })))));
      })));
    } else return null;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "app-container finpro-agency-profile"
  }, /*#__PURE__*/_react.default.createElement(ProcessHeadtags, null), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Jumbotron, {
    variant: "dark-primary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-media-object reverse"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "body"
  }, !(0, _lodash.isEmpty)(extractedFields.agencyName) && /*#__PURE__*/_react.default.createElement("h2", null, extractedFields.agencyName), /*#__PURE__*/_react.default.createElement("div", {
    className: "profile-contact-link"
  }, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetPhone, {
    value: extractedFields.location.phone
  }), /*#__PURE__*/_react.default.createElement(GetLeadFormLink, null)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 6,
    sm: 12,
    className: "mm-spacing--minor",
    itemscope: "",
    itemtype: "http://schema.org/InsuranceAgency"
  }, /*#__PURE__*/_react.default.createElement("h3", null, extractedFields.officeType), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetAddress, _extends({}, extractedFields.location, {
    schema: true
  })), /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetGoogleMapLink, extractedFields.location), !(0, _lodash.isEmpty)(extractedFields.agencyWebsiteUrl) && /*#__PURE__*/_react.default.createElement("div", {
    className: "link-padding"
  }, /*#__PURE__*/_react.default.createElement(_CTAButton.default, {
    buttonType: 'inline',
    target: '_blank',
    label: 'Visit Agency Website',
    icon: 'icon-external-link',
    iconDirection: 'left',
    href: extractedFields.agencyWebsiteUrl
  })), socialLinksAvailable && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "finpro-social-link"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_FinproProfileUtility.GetSocialLinks, extractedFields.socialAppList))), /*#__PURE__*/_react.default.createElement("div", {
    className: "link-padding"
  }, /*#__PURE__*/_react.default.createElement(_DisclosureModal.default, _extends({}, extractedFields.disclosures, {
    userType: 'agency',
    id: 'modal-disclosures',
    label: 'See our Licenses and Disclosures'
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 6,
    sm: 12,
    className: "agency-map-col"
  }, /*#__PURE__*/_react.default.createElement(_SinglePinMap.SinglePinMap, {
    lat: extractedFields === null || extractedFields === void 0 || (_extractedFields$loca = extractedFields.location) === null || _extractedFields$loca === void 0 ? void 0 : _extractedFields$loca.latitude,
    lng: extractedFields === null || extractedFields === void 0 || (_extractedFields$loca2 = extractedFields.location) === null || _extractedFields$loca2 === void 0 ? void 0 : _extractedFields$loca2.longitude
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4,
    md: 12,
    sm: 12,
    className: "mm-spacing--minor"
  }, !isCoreoffice && /*#__PURE__*/_react.default.createElement(GetCoreOffice, null), isCoreoffice && /*#__PURE__*/_react.default.createElement(GetSatelliteOffice, null)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-spacing--minor"
  }, /*#__PURE__*/_react.default.createElement("hr", null), /*#__PURE__*/_react.default.createElement(_ListAgents.default, {
    agents: extractedFields.agents,
    managingAgents: extractedFields.managingAgents,
    featuredAgents: extractedFields.featuredAgents,
    coreAgencyNumber: extractedFields.coreAgencyNumber,
    subAgencyNumber: extractedFields.subAgencyNumber,
    agencyName: extractedFields.agencyName,
    onLeadModelShow: handleLeadFormModalShow,
    showForm: showForm
  })), showForm && /*#__PURE__*/_react.default.createElement(_LeadFormModal.default, {
    formData: formData,
    show: showLeadForm,
    data: leadFormData,
    onModelClose: handleLeadFormModalClose
  }));
}
var _default = exports.default = FinproAgencyProfile;